import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import Grid from 'components/UI/Grid';
import api from 'Api/ApiMethods';
import { Agent } from 'models/restTypes';
import AgentsTable from './AgentsTable';

const Container = styled(Grid)`
  height: 100%;
  width: 100%;
  justify-content: flex-start;
`;

const Agents: FC = observer(() => {
  const [data, setData] = useState<Agent[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    api
      .getStaticDataAgents()
      .then((response) => {
        setData(response);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <Container>
      <AgentsTable agents={data} isLoading={loading} />
    </Container>
  );
});

export default Agents;
